import { firestore } from 'firebase/app'
import Vue from 'vue'
import { Model } from 'vue-mc'
import { fetch, save, _delete } from './FirestoreCommon'

export default class FirestoreModel extends Model {
  fetch (params) { return fetch.call(this, params) }
  save (params) { return save.call(this, params) }
  delete (params) { return _delete.call(this, params) }

  getModelName () {
    const collection = this.getURL(this.getSaveRoute())

    return this.modelName ||
      collection.charAt(0).toUpperCase() + collection.slice(1)
  }

  onFetchSuccess (doc) {
    let attributes = null

    if (doc.exists) {
      attributes = doc.data()
      attributes.id = doc.id
    } else {
      throw String('No data in fetch response')
    }

    // Transform Firebase Timestamps objects to JS Date objects
    for (let attr in attributes) {
      if (attributes[attr] instanceof firestore.Timestamp) {
        attributes[attr] = attributes[attr].toDate()
      }
    }

    this.assign(attributes)

    Vue.set(this, 'fatal', false)
    Vue.set(this, 'loading', false)

    this.emit('fetch', { error: null })
  }

  onSaveSuccess (data) {
    // Clear errors because the request was successful.
    this.clearErrors()

    // Update this model with the data that was returned in the response.
    if (data) {
      this.update(data)
    }

    Vue.set(this, 'saving', false)
    Vue.set(this, 'fatal', false)

    // Automatically add to all registered collections.
    this.addToAllCollections()

    this.emit('save', { error: null })
  }

  onSaveFailure (error) {
    if (this.isBackendValidationError(error)) {
      this.onSaveValidationFailure(error)
    } else {
      this.onFatalSaveFailure(error)
    }

    this.emit('save', { error })
  }

  getSaveData () {
    // Remove identifier before saving
    let { id, ...withoutId } = this._attributes
    return withoutId
  }

  routes () {
    return {
      fetch: this.collection,
      save: this.collection,
      delete: this.collection
    }
  }
}
